// react
import React, { useState } from "react";

// react-router-dom
import { useNavigate } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// react-18next
import { useTranslation } from "react-i18next";

// @mui
import { Box, Grid, TextField, Button, Typography, Checkbox, FormControlLabel, useMediaQuery } from "@mui/material";

// user-controller
import postNewUser from "user-controller/postNewUser";

// A ---------------------------------------------------------------------- M

const NewUser = () => {
  const { clientData } = UserAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [email, setEmail] = useState("");
  const [canCreateDatabox, setCanCreateDatabox] = useState(false);
  const [canCreateGroup, setCanCreateGroup] = useState(false);
  const [canSign, setCanSign] = useState(false);
  const [isReseller, setIsReseller] = useState(false);
  const [canAddUser, setCanAddUser] = useState(false);
  const [conservSostL1, setConservSostL1] = useState(false);

  const handleSave = async () => {
    await postNewUser(email, clientData ? clientData.id : "", canCreateDatabox, canCreateGroup, canSign, isReseller, false, canAddUser, conservSostL1);
    navigate("/");
  };

  const handleConservChange = (checked) => {
    setConservSostL1(checked);
    if (checked) {
      setCanCreateDatabox(false);
      setCanCreateGroup(false);
      setCanSign(false);
      setIsReseller(false);
      setCanAddUser(false);
    }
  };

  const handleToggle =
    (setter) =>
    ({ target: { checked } }) => {
      setter(checked);
      if (checked) setConservSostL1(false);
    };

  const fieldStyles = { "& .MuiInputBase-root": { borderRadius: 1 } };
  const buttonStyles = {
    textTransform: "none",
    borderRadius: 1,
    boxShadow: "none",
    borderColor: "divider",
    px: 3,
    py: isMobile ? 0.5 : 1,
    "&:hover": { backgroundColor: "action.hover", borderColor: "primary.main" },
  };

  return (
    <Box
      sx={{
        maxWidth: isMobile ? "100%" : 500,
        mx: "auto",
        mt: 8,
        p: isMobile ? 2 : 4,
        boxShadow: 1,
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h6" fontWeight="bold" align="center" gutterBottom>
        {t("new_user")}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField label={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} fullWidth size="small" sx={fieldStyles} />
        </Grid>
        <Grid item xs={12}>
          <TextField label={t("customer_name")} value={clientData ? clientData.companyName || clientData.id : "N/A"} InputProps={{ readOnly: true }} fullWidth size="small" sx={fieldStyles} />
        </Grid>
        <Grid item xs={12} container spacing={1}>
          {[
            { label: "canCreateDatabox", state: canCreateDatabox, setter: setCanCreateDatabox },
            { label: "canCreateGroup", state: canCreateGroup, setter: setCanCreateGroup },
            { label: "canSign", state: canSign, setter: setCanSign },
            { label: "isReseller", state: isReseller, setter: setIsReseller },
            { label: "canAddUser", state: canAddUser, setter: setCanAddUser },
          ].map(({ label, state, setter }) => (
            <Grid item xs={6} sm={4} key={label}>
              <FormControlLabel control={<Checkbox size="small" checked={state} onChange={handleToggle(setter)} disabled={conservSostL1} />} label={t(label)} />
            </Grid>
          ))}
          <Grid item xs={6} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={conservSostL1}
                  onChange={(e) => handleConservChange(e.target.checked)}
                  disabled={canCreateDatabox || canCreateGroup || canSign || isReseller || canAddUser}
                />
              }
              label={t("conservSostL1")}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
          <Button variant="outlined" onClick={handleSave} disabled={!email} sx={buttonStyles}>
            {t("add")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewUser;
